// Day 6 - Full Production Content (PREMIUM)
// Temat: AI dla kreatywności i brainstormingu
// Ton: inspirujący, praktyczny, premium
// Duration: 12-15 minutes

export const day6Content = {
  day_number: 6,
  title: "AI dla kreatywności",
  subtitle: "Brainstorming i innowacje",
  duration: "12-15 min",
  is_premium: true,
  has_ai_coach: true,
  exercises: [
    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 1: AI jako partner kreatywny (5 kroków)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d6_ex1",
      title: "AI jako partner kreatywny",
      icon: "sparkles",
      steps: [
        {
          id: "d6_ex1_s1",
          type: "choice",
          title: "Mit kreatywności AI",
          content: "Czy AI jest naprawdę kreatywne?",
          options: [
            { id: "a", text: "Tak, AI ma własne pomysły", correct: false },
            { id: "b", text: "AI łączy istniejące wzorce w nowe kombinacje – to TY nadajesz kierunek", correct: true },
            { id: "c", text: "Nie, AI nie może być kreatywne", correct: false },
            { id: "d", text: "AI zastąpi artystów", correct: false }
          ],
          shuffle: true,
          softHint: "AI to narzędzie – Twoja wizja + możliwości AI = kreatywność.",
          successMessage: "Dokładnie! AI rekombinuje wzorce, Ty dajesz wizję i kierunek."
        },
        {
          id: "d6_ex1_s2",
          type: "choice",
          title: "Siła AI w brainstormingu",
          content: "Dlaczego AI jest świetne do brainstormingu?",
          options: [
            { id: "a", text: "Bo zawsze ma rację", correct: false },
            { id: "b", text: "Może wygenerować wiele różnorodnych pomysłów szybko, bez autocenzury", correct: true },
            { id: "c", text: "Bo jest inteligentniejsze od ludzi", correct: false },
            { id: "d", text: "Bo nie potrzebujesz już myśleć", correct: false }
          ],
          shuffle: true,
          softHint: "AI nie ocenia, nie boi się głupich pomysłów – to idealne do burzy mózgów.",
          successMessage: "Tak! AI generuje bez autocenzury – więcej surowca do wyboru."
        },
        {
          id: "d6_ex1_s3",
          type: "choice",
          title: "Rola człowieka",
          content: "Jaka jest Twoja rola w kreatywnym procesie z AI?",
          options: [
            { id: "a", text: "Bierna – AI robi wszystko", correct: false },
            { id: "b", text: "Selekcja, ocena, łączenie i rozwijanie pomysłów AI", correct: true },
            { id: "c", text: "Tylko zatwierdzanie", correct: false },
            { id: "d", text: "Nie ma roli – AI jest lepsze", correct: false }
          ],
          shuffle: true,
          softHint: "Ty wybierasz diamenty z surowca, który generuje AI.",
          successMessage: "Właśnie! AI generuje ilość, Ty wybierasz jakość i rozwijasz."
        },
        {
          id: "d6_ex1_s4",
          type: "choice",
          title: "Proces kreatywny",
          content: "Najlepszy przepływ kreatywnej pracy z AI to:",
          options: [
            { id: "a", text: "Jeden prompt → jeden wynik → koniec", correct: false },
            { id: "b", text: "Generowanie → selekcja → rozwijanie → iteracja", correct: true },
            { id: "c", text: "Kopiowanie pierwszego wyniku", correct: false },
            { id: "d", text: "Bez planu, na żywioł", correct: false }
          ],
          shuffle: true,
          softHint: "Kreatywność to proces iteracyjny, nie jednorazowy strzał.",
          successMessage: "Tak! Iteracja to klucz – generuj, wybieraj, rozwijaj, powtarzaj."
        },
        {
          id: "d6_ex1_s5",
          type: "fill",
          title: "Zasada brainstormingu",
          content: "Dokończ zdanie o brainstormingu:",
          template: "W brainstormingu najpierw chcę _______, potem oceniam.",
          correctAnswers: ["ilość", "dużo", "wiele", "wszystko", "pomysłów", "opcji"],
          minLength: 3,
          softHint: "Najpierw ilość, potem jakość – nie oceniaj za wcześnie!",
          successMessage: "Dokładnie! Najpierw ILOŚĆ, potem selekcja jakości."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 2: Techniki brainstormingu (6 kroków)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d6_ex2",
      title: "Techniki brainstormingu z AI",
      icon: "brain",
      steps: [
        {
          id: "d6_ex2_s1",
          type: "choice",
          title: "Technika: Quantity Dump",
          content: "Co to jest 'quantity dump'?",
          options: [
            { id: "a", text: "Prośba o jeden dobry pomysł", correct: false },
            { id: "b", text: "Prośba o jak najwięcej pomysłów bez oceny (np. 20, 50, 100)", correct: true },
            { id: "c", text: "Usuwanie złych pomysłów", correct: false },
            { id: "d", text: "Kopiowanie cudzych pomysłów", correct: false }
          ],
          shuffle: true,
          softHint: "Dump = 'wyrzuć wszystko' – ilość bez filtrowania.",
          successMessage: "Tak! Quantity dump: 'Daj mi 30 pomysłów na X, nie oceniaj ich'."
        },
        {
          id: "d6_ex2_s2",
          type: "choice",
          title: "Technika: Różne perspektywy",
          content: "Który prompt da najbardziej różnorodne pomysły?",
          options: [
            { id: "a", text: "\"Daj pomysły na marketing\"", correct: false },
            { id: "b", text: "\"Daj 5 pomysłów z perspektywy: CEO, dziecka, artysty, inżyniera, psychologa\"", correct: true },
            { id: "c", text: "\"Najlepszy pomysł na marketing\"", correct: false },
            { id: "d", text: "\"Co robią konkurenci?\"", correct: false }
          ],
          shuffle: true,
          softHint: "Różne role/perspektywy = różnorodne pomysły.",
          successMessage: "Właśnie! Perspektywy wymuszają różnorodność myślenia."
        },
        {
          id: "d6_ex2_s3",
          type: "choice",
          title: "Technika: What If",
          content: "Jak działa technika 'What If' (Co jeśli)?",
          options: [
            { id: "a", text: "Pytasz AI co będzie w przyszłości", correct: false },
            { id: "b", text: "Zadajesz hipotetyczne scenariusze: 'Co jeśli budżet byłby nieograniczony?'", correct: true },
            { id: "c", text: "Pytasz o fakty", correct: false },
            { id: "d", text: "Sprawdzasz co jest możliwe", correct: false }
          ],
          shuffle: true,
          softHint: "What If usuwa ograniczenia – otwiera nowe możliwości.",
          successMessage: "Tak! 'What If' łamie założenia i otwiera kreatywność."
        },
        {
          id: "d6_ex2_s4",
          type: "shortPrompt",
          title: "Stwórz prompt brainstormingowy",
          content: "Napisz prompt na brainstorming 20 pomysłów na nową funkcję w aplikacji:",
          placeholder: "Wygeneruj 20 pomysłów na...",
          minLength: 60,
          requiredElements: ["20|dwadzieścia|wiele", "pomysł|idea", "funkcj|feature|aplikacj"],
          softHint: "Poproś o ilość, różnorodność, bez oceny.",
          successMessage: "Świetny prompt brainstormingowy! Teraz przetestuj go."
        },
        {
          id: "d6_ex2_s5",
          type: "choice",
          title: "Technika: Odwrotne myślenie",
          content: "Na czym polega 'odwrotne myślenie'?",
          options: [
            { id: "a", text: "Myślenie do tyłu", correct: false },
            { id: "b", text: "Pytanie 'Jak sprawić, żeby to NIE działało?' i odwrócenie wniosków", correct: true },
            { id: "c", text: "Robienie odwrotnie niż konkurencja", correct: false },
            { id: "d", text: "Zaprzeczanie wszystkiemu", correct: false }
          ],
          shuffle: true,
          softHint: "Czasem łatwiej wymyślić co NIE robić, a potem odwrócić.",
          successMessage: "Dokładnie! 'Jak zepsuć X?' → odwróć → 'Jak poprawić X?'"
        },
        {
          id: "d6_ex2_s6",
          type: "reorder",
          title: "Proces brainstormingu",
          content: "Ułóż optymalny proces brainstormingu z AI:",
          items: [
            { id: "r1", text: "Zdefiniuj problem lub cel", order: 1 },
            { id: "r2", text: "Wygeneruj dużo pomysłów (quantity dump)", order: 2 },
            { id: "r3", text: "Dodaj różne perspektywy i techniki", order: 3 },
            { id: "r4", text: "Wybierz 3-5 najlepszych", order: 4 },
            { id: "r5", text: "Rozwiń wybrane pomysły głębiej", order: 5 }
          ],
          softHint: "Problem → ilość → różnorodność → selekcja → rozwinięcie",
          successMessage: "To jest profesjonalny proces brainstormingu!"
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 3: Kreatywne pisanie z AI (5 kroków)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d6_ex3",
      title: "Kreatywne pisanie",
      icon: "edit",
      steps: [
        {
          id: "d6_ex3_s1",
          type: "choice",
          title: "AI jako współautor",
          content: "Jak najlepiej używać AI do pisania kreatywnego?",
          options: [
            { id: "a", text: "Generować całość i publikować bez zmian", correct: false },
            { id: "b", text: "Jako współautora: AI daje drafty/pomysły, Ty edytujesz i nadajesz głos", correct: true },
            { id: "c", text: "Nie używać AI do kreatywności", correct: false },
            { id: "d", text: "Tylko do korekty błędów", correct: false }
          ],
          shuffle: true,
          softHint: "Współpraca: AI generuje surowiec, Ty kształtujesz finalny produkt.",
          successMessage: "Tak! AI = współautor, nie autor. Twój głos nadaje unikalność."
        },
        {
          id: "d6_ex3_s2",
          type: "choice",
          title: "Technika: Styl i ton",
          content: "Jak kontrolować styl pisania AI?",
          options: [
            { id: "a", text: "Nie da się kontrolować", correct: false },
            { id: "b", text: "Podając przykłady stylu lub opisując ton (np. 'pisz jak Hemingway')", correct: true },
            { id: "c", text: "Prosząc o losowy styl", correct: false },
            { id: "d", text: "Zostawiając domyślne ustawienia", correct: false }
          ],
          shuffle: true,
          softHint: "Przykłady i opisy tonu kierują stylem AI.",
          successMessage: "Właśnie! 'Pisz w stylu X' lub 'ton: Y' daje kontrolę."
        },
        {
          id: "d6_ex3_s3",
          type: "choice",
          title: "Przełamywanie blokady twórczej",
          content: "Jak AI może pomóc z blokadą twórczą?",
          options: [
            { id: "a", text: "Napisać wszystko za Ciebie", correct: false },
            { id: "b", text: "Dać pierwszy draft, alternatywne podejścia, lub 'rozgrzewkowe' teksty", correct: true },
            { id: "c", text: "Nie może pomóc", correct: false },
            { id: "d", text: "Tylko przez zmianę tematu", correct: false }
          ],
          shuffle: true,
          softHint: "Czasem potrzebujesz tylko punktu startowego – AI daje ten impuls.",
          successMessage: "Tak! AI przełamuje 'pustą stronę' – daje punkt wyjścia."
        },
        {
          id: "d6_ex3_s4",
          type: "shortPrompt",
          title: "Prompt na kreatywne pisanie",
          content: "Napisz prompt na wygenerowanie 5 różnych otwarć artykułu o produktywności:",
          placeholder: "Jako copywriter, napisz 5 różnych...",
          minLength: 60,
          requiredElements: ["5|pięć", "otwar|począt|hook|wstęp", "artykuł|tekst|produkt"],
          softHint: "Poproś o różne style: pytanie, statystyka, historia, prowokacja...",
          successMessage: "Świetny prompt! Różne otwarcia = więcej opcji do wyboru."
        },
        {
          id: "d6_ex3_s5",
          type: "choice",
          title: "Autentyczność",
          content: "Jak zachować autentyczny głos używając AI?",
          options: [
            { id: "a", text: "Kopiować wszystko bez zmian", correct: false },
            { id: "b", text: "Edytować, dodawać własne doświadczenia i perspektywę", correct: true },
            { id: "c", text: "Nie używać AI", correct: false },
            { id: "d", text: "Ukrywać użycie AI", correct: false }
          ],
          shuffle: true,
          softHint: "Twoje doświadczenia i perspektywa = autentyczność.",
          successMessage: "Dokładnie! AI daje strukturę, Ty dodajesz duszę."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 4: Innowacje i rozwiązywanie problemów (5 kroków)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d6_ex4",
      title: "Innowacje i problem-solving",
      icon: "target",
      steps: [
        {
          id: "d6_ex4_s1",
          type: "choice",
          title: "AI jako konsultant innowacji",
          content: "Jak AI może wspierać innowacje?",
          options: [
            { id: "a", text: "Wymyślając wszystko za Ciebie", correct: false },
            { id: "b", text: "Pokazując nieoczywiste połączenia, analogie z innych branż, alternatywne rozwiązania", correct: true },
            { id: "c", text: "Kopiując istniejące rozwiązania", correct: false },
            { id: "d", text: "Nie może wspierać innowacji", correct: false }
          ],
          shuffle: true,
          softHint: "AI widzi wzorce z wielu dziedzin – może sugerować połączenia.",
          successMessage: "Tak! AI łączy wiedzę z różnych domen – świetne dla innowacji."
        },
        {
          id: "d6_ex4_s2",
          type: "choice",
          title: "Technika: Analogie",
          content: "Jak użyć analogii w rozwiązywaniu problemów?",
          options: [
            { id: "a", text: "Szukać identycznych problemów", correct: false },
            { id: "b", text: "Pytać AI: 'Jak ten problem rozwiązano w [inna branża/natura/historia]?'", correct: true },
            { id: "c", text: "Kopiować konkurencję", correct: false },
            { id: "d", text: "Ignorować inne branże", correct: false }
          ],
          shuffle: true,
          softHint: "Analogie z innych dziedzin przynoszą świeże perspektywy.",
          successMessage: "Właśnie! 'Jak to rozwiązano w przyrodzie/lotnictwie/medycynie?' = innowacja."
        },
        {
          id: "d6_ex4_s3",
          type: "choice",
          title: "Technika: First Principles",
          content: "Co to jest 'myślenie od podstaw' (first principles)?",
          options: [
            { id: "a", text: "Kopiowanie najlepszych praktyk", correct: false },
            { id: "b", text: "Rozbicie problemu na fundamentalne elementy i budowanie od zera", correct: true },
            { id: "c", text: "Zaczynanie od najprostszego rozwiązania", correct: false },
            { id: "d", text: "Stosowanie się do zasad", correct: false }
          ],
          shuffle: true,
          softHint: "Rozbij na atomy: 'Co NAPRAWDĘ jest tu potrzebne?'",
          successMessage: "Tak! First principles: odrzuć założenia, zbuduj od podstaw."
        },
        {
          id: "d6_ex4_s4",
          type: "shortPrompt",
          title: "Prompt na innowację",
          content: "Napisz prompt prosząc AI o 5 innowacyjnych rozwiązań problemu zużycia plastiku, używając analogii z natury:",
          placeholder: "Analizując jak natura rozwiązuje problem...",
          minLength: 70,
          requiredElements: ["natur|biolog|przyroda", "plastik|opakowa", "5|pięć|rozwią|innowac"],
          softHint: "Połącz problem + analogię (natura) + prośbę o ilość rozwiązań.",
          successMessage: "Świetny prompt łączący techniki! To jest myślenie innowatora."
        },
        {
          id: "d6_ex4_s5",
          type: "choice",
          title: "Od pomysłu do realizacji",
          content: "Co robić po wygenerowaniu innowacyjnych pomysłów?",
          options: [
            { id: "a", text: "Realizować wszystkie na raz", correct: false },
            { id: "b", text: "Ocenić wykonalność, wybrać najlepsze, stworzyć plan testowania", correct: true },
            { id: "c", text: "Zachować na później", correct: false },
            { id: "d", text: "Szukać jeszcze więcej pomysłów", correct: false }
          ],
          shuffle: true,
          softHint: "Pomysły bez działania to tylko słowa – testuj i wdrażaj!",
          successMessage: "Dokładnie! Pomysł → ocena → plan → test → wdrożenie."
        }
      ]
    },

    // ═══════════════════════════════════════════════════════════════
    // ĆWICZENIE 5: Podsumowanie (3 kroki)
    // ═══════════════════════════════════════════════════════════════
    {
      id: "d6_ex5",
      title: "Podsumowanie",
      icon: "trophy",
      steps: [
        {
          id: "d6_ex5_s1",
          type: "choice",
          title: "Quiz: Rola AI w kreatywności",
          content: "Jaka jest główna rola AI w procesie kreatywnym?",
          options: [
            { id: "a", text: "Zastąpić ludzką kreatywność", correct: false },
            { id: "b", text: "Generować surowiec i różnorodność, którą TY selekcjonujesz i rozwijasz", correct: true },
            { id: "c", text: "Oceniać Twoje pomysły", correct: false },
            { id: "d", text: "Podejmować decyzje kreatywne", correct: false }
          ],
          shuffle: true,
          softHint: "AI = generator, Ty = kurator i twórca finalnego dzieła.",
          successMessage: "Tak! AI generuje, Ty wybierasz i kształtujesz."
        },
        {
          id: "d6_ex5_s2",
          type: "choice",
          title: "Quiz: Najlepsza technika",
          content: "Którą technikę użyjesz dla maksymalnej różnorodności pomysłów?",
          options: [
            { id: "a", text: "Jeden konkretny prompt", correct: false },
            { id: "b", text: "Quantity dump + różne perspektywy + techniki jak 'What If'", correct: true },
            { id: "c", text: "Kopiowanie konkurencji", correct: false },
            { id: "d", text: "Oczekiwanie na inspirację", correct: false }
          ],
          shuffle: true,
          softHint: "Łącz techniki dla maksymalnej różnorodności.",
          successMessage: "Właśnie! Kombinacja technik = bogactwo pomysłów."
        },
        {
          id: "d6_ex5_s3",
          type: "choice",
          title: "Dzień 6 ukończony!",
          content: "Co dalej?",
          options: [
            { id: "a", text: "Wróć do listy lekcji", isChoice: true },
            { id: "b", text: "Wypróbuj AI Coacha do brainstormingu", isChoice: true }
          ],
          shuffle: false,
          softHint: "Wybierz swoją ścieżkę!",
          successMessage: "Dzień 6 za Tobą! Jesteś teraz kreatywnym partnerem AI. Jutro: analiza i research!"
        }
      ]
    }
  ]
};

export default day6Content;
